import { Box, SxProps, Theme } from "@mui/material";
import WorkItemSelectField from "../shared/WorkItemSelectField";

interface IWorkItemSearchFieldWorkspaceProps {
    idSuffix: string,
    labelProps?: SxProps<Theme> | undefined,
    onChange: (e: number[]) => void;    
    options?: any[];
    multiple?: boolean;
}

const WorkItemSearchFieldWorkspace = (props: IWorkItemSearchFieldWorkspaceProps) => {
    return (
        <>
            <Box>
                <WorkItemSelectField 
                    idSuffix={props.idSuffix}
                    options={props.options} 
                    labelProps={props.labelProps}
                    multiple={props.multiple === undefined ? true : props.multiple} 
                    label="Workspace" 
                    onChange={s => props.onChange(s)} />
            </Box>
        </>
    );
}


export default WorkItemSearchFieldWorkspace;